import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormMasterModule } from '../form-master/form-master.module';
import { SharedModule } from '../shared/shared.module';
import { SearchComponent } from './search.component';

const components = [SearchComponent];

@NgModule({
  imports: [CommonModule, SharedModule, FormMasterModule],
  declarations: [...components],
  exports: [...components],
})
export class SearchModule {}
